module.exports = function() {
  return new Worker(__webpack_public_path__ + "81a587f43a1d4cf251db.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./node_modules/react-pdf/dist/pdf.worker.entry.js
// module id = 82
// module chunks = 1 2 3 4 5 6 7 8